'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSponsorships } from '@sola/supporter-sdk/hooks/commitments.ts';
import { NameFormats, useSupporterName } from '@sola/supporter-sdk/hooks/details.ts';
export interface GreetingLanguage {
  key: string;
  greeting: string;
  name: string;
  flag: string;
}
const countryToGreetingKey: Record<string, string> = {
  'burkina faso': 'burkinaFaso',
  ethiopia: 'ethiopia',
  ghana: 'ghana',
  kenya: 'kenya',
  rwanda: 'rwanda',
  peru: 'peru',
  bangladesh: 'bangladesh',
  indonesia: 'indonesia',
  philippines: 'philippines',
  haiti: 'haiti'
};
const getGreetingKeyForCountry = (country: string): string | undefined => {
  const normalized = country.toLowerCase();
  return countryToGreetingKey[normalized];
};
const getRandomIndex = (length: number): number => {
  if (length <= 0) {
    return 0;
  }
  return Math.floor(Math.random() * length);
};
const defaultGreeting: GreetingLanguage = {
  key: 'en',
  greeting: 'Hello',
  name: 'English',
  flag: '🇺🇸'
};
export const useHomepageGreeting = () => {
  const $ = _c(21);
  const {
    t
  } = useTranslation("greetings");
  const name = useSupporterName(NameFormats.preferred);
  const {
    sponsorships,
    isLoading
  } = useSponsorships();
  let t0;
  if ($[0] !== t) {
    t0 = t("languages", {
      returnObjects: true
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const languagesMap = t0 as Record<string, {
    greeting: string;
    name: string;
    flag: string;
  }>;
  let t1;
  if ($[2] !== languagesMap) {
    t1 = Object.entries(languagesMap).map(_temp);
    $[2] = languagesMap;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const languages = t1;
  let t2;
  bb0: {
    if (languages.length === 0) {
      t2 = defaultGreeting;
      break bb0;
    }
    if (!isLoading) {
      let t3;
      if ($[4] !== sponsorships) {
        t3 = new Set(sponsorships.map(_temp2).filter(_temp3).map(_temp4).filter(_temp5));
        $[4] = sponsorships;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      const matchingKeys = t3;
      let t4;
      if ($[6] !== languages || $[7] !== matchingKeys) {
        t4 = languages.filter(lang => matchingKeys.has(lang.key));
        $[6] = languages;
        $[7] = matchingKeys;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      const matchingLanguages = t4;
      if (matchingLanguages.length === 1) {
        t2 = matchingLanguages[0];
        break bb0;
      }
      if (matchingLanguages.length > 1) {
        t2 = matchingLanguages[getRandomIndex(matchingLanguages.length)];
        break bb0;
      }
    }
    let t3;
    if ($[9] !== languages) {
      t3 = languages[getRandomIndex(languages.length)] ?? defaultGreeting;
      $[9] = languages;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = t3;
  }
  const selectedLanguage = t2;
  let t3;
  if ($[11] !== t) {
    t3 = t("subtitle");
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const subtitle = t3;
  let t4;
  if ($[13] !== t) {
    t4 = languageName => t("flagTooltip", {
      language: languageName
    });
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const getFlagTooltip = t4;
  const t5 = name ?? "";
  let t6;
  if ($[15] !== getFlagTooltip || $[16] !== languages || $[17] !== selectedLanguage || $[18] !== subtitle || $[19] !== t5) {
    t6 = {
      name: t5,
      selectedLanguage,
      languages,
      subtitle,
      getFlagTooltip
    };
    $[15] = getFlagTooltip;
    $[16] = languages;
    $[17] = selectedLanguage;
    $[18] = subtitle;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
function _temp(t0) {
  const [key, value] = t0;
  return {
    key,
    greeting: value.greeting,
    name: value.name,
    flag: value.flag
  };
}
function _temp2(s) {
  return s.participant?.country;
}
function _temp3(country) {
  return !!country;
}
function _temp4(country_0) {
  return getGreetingKeyForCountry(country_0);
}
function _temp5(key_0) {
  return !!key_0;
}